export default {
    default: 'ru',
}
